export default {
    default: 'ru',
}
